// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yv-1";
export var printerIcon = "_yv-0";